import React from "react";
import Link from "gatsby-link";
import moment from "moment";
import { getRoomPrice } from "../../utils/app-helpers";
import GatsbyConfig from "../../../gatsby-config.js";

const { siteMetadata: config } = GatsbyConfig;

export default class BookCallout extends React.Component {
  render() {
    const { trip } = this.props;
    const tripData = config.trips[trip];
    const price = getRoomPrice(
      tripData,
      tripData.rooms[Object.keys(tripData.rooms)[0]]
    );
    const maxMonths = tripData.maxSubMonths;
    const subscriptionFee = tripData.subscriptionFee;
    const useMaxSubMonthsCutoff = moment(
      tripData.useMaxSubMonthsCutoff,
      "MM-DD-YYYY"
    );
    const availabilityCutoff = moment(
      tripData.availabilityCutoff,
      "MM-DD-YYYY"
    );
    const today = moment(new Date());
    let planChangeDay;
    let xMonths;
    if (today.valueOf() > useMaxSubMonthsCutoff.valueOf()) {
      xMonths = Math.floor(availabilityCutoff.diff(today, "months", true)) + 1;
      if (xMonths > maxMonths) xMonths = maxMonths;
    } else {
      xMonths = maxMonths;
    }
    const lowestPrice = Math.round((price + subscriptionFee) / xMonths / 2);

    return (
      <div className="book-callout">
        <div className="wrap">
          <h2>Join us&hellip;</h2>
          {trip === "maui" ? (
            <div>
              <p>
                Picture this… You blissfully awaken to the soft rays of the sun
                warming your face… step out of your oversized guest room onto
                your lanai to delight in the tropical surroundings… take an
                early morning stroll along the sandy beach, hand-in-hand with
                your spouse… then head over to the elegant Ritz-Carlton ballroom
                to sing praises to the Lord during morning worship led by
                MercyMe, followed by a teaching from Dr. Gary Chapman, author of
                The 5 Love Languages… then it’s off to the pool to take a dip in
                the refreshing aqua blue pool… and that’s just the beginning!
              </p>
              <p>
                The Love Song Couples Getaway will allow you and your spouse to
                escape from the stresses of day-to-day life by spending a week
                together, enjoying beaches, sunsets, and most importantly time
                with each other and the Lord. Join us on the Love Song Couples
                Getaway, {tripData.dates} at the exquisite 5-Star Ritz-Carlton,
                Kapalua, Maui, and create memories that will last a lifetime!
              </p>
            </div>
          ) : trip === "maui2019" ? (
            <div>
              <p>
                Picture this… You blissfully awaken to the soft rays of the sun
                warming your face… step out of your oversized guest room onto
                your lanai to delight in the tropical surroundings… take an
                early morning stroll along the sandy beach, hand-in-hand with
                your spouse… then head over to the elegant Ritz-Carlton ballroom
                to sing praises to the Lord during morning worship led by
                MercyMe, followed by a teaching from Dr. Gary Chapman, author of
                The 5 Love Languages… then it’s off to the pool to take a dip in
                the refreshing aqua blue pool… and that’s just the beginning!
              </p>
              <p>
                The Love Song Couples Getaway will allow you and your spouse to
                escape from the stresses of day-to-day life by spending a week
                together, enjoying beaches, sunsets, and most importantly time
                with each other and the Lord. Join us on the Love Song Couples
                Getaway, {tripData.dates} at the exquisite 5-Star Ritz-Carlton,
                Kapalua, Maui, and create memories that will last a lifetime!
              </p>
            </div>
          ) : trip === "cancun" ? (
            <div>
              <p>
                It’s time for you and your spouse to take a week away from your
                busy, day-to-day routines and focus solely on strengthening your
                marriage, having fun together, diving into the Word, worshipping
                the Lord, and fellowshipping with other believers, all while
                enjoying the ultimate vacation destination, {tripData.location}!
              </p>
              <p>
                On the Love Song Couples Getaway, you will take in teachings
                from Gary Thomas, author of Sacred Marriage, and New York Times
                Best-Seller, Max Lucado, and be led in worship by chart topping
                Christian artists MercyMe and Francesca Battistelli. We invite
                you to join us on this unforgettable experience,{" "}
                {tripData.dates}, for a time filled with romance, adventure, and
                spiritual growth!
              </p>
            </div>
          ) : trip === "cancun2020" ? (
            <div>
              <p>
                It’s time for you and your spouse to take a week away from your
                busy, day-to-day routines and focus solely on strengthening your
                marriage, having fun together, diving into the Word, worshipping
                the Lord, and fellowshipping with other believers, all while
                enjoying the ultimate vacation destination, {tripData.location}!
              </p>
              <p>
                On the Love Song Couples Getaway, you will take in teachings
                from Gary Thomas, author of Sacred Marriage, and New York Times
                Best-Seller, Max Lucado, and be led in worship by chart topping
                Christian artists Mark Hall of Casting Crowns, MercyMe, and
                Francesca Battistelli. We invite you to join us on this
                unforgettable experience, {tripData.dates}, for a time filled
                with romance, adventure, and spiritual growth!
              </p>
            </div>
          ) : trip === "cancun2021" ? (
            <div>
              <p>
                It’s time for you and your spouse to take a week away from your
                busy, day-to-day routines and focus solely on strengthening your
                marriage, having fun together, diving into the Word, worshipping
                the Lord, and fellowshipping with other believers, all while
                enjoying the ultimate vacation destination, {tripData.location}!
              </p>
              <p>
                On the Love Song Couples Getaway, you will take in teachings
                from Gary Thomas, author of Sacred Marriage, and New York Times
                Best-Seller, Max Lucado, and be led in worship by chart topping
                Christian artists Mark Hall of Casting Crowns, MercyMe, and
                Francesca Battistelli. We invite you to join us on this
                unforgettable experience, {tripData.dates}, for a time filled
                with romance, adventure, and spiritual growth!
              </p>
            </div>
          ) : trip === "kauai2019" ? (
            <div>
              <p>
                Picture this, you blissfully awaken to the soft rays of the sun
                warming your face… …step out of your oversized guest room onto
                your lanai to delight in the tropical surroundings… …walk along
                the sandy beach hand-in-hand with your spouse… …take a stroll
                over to the ballroom for a powerful message that will bless your
                marriage… …then it’s off to the pool to take a dip in the
                refreshing aqua blue water… …and that’s just the beginning! The
                Love Song Couples Getaway will allow you and your spouse to
                escape from the stresses of day-to-day life by spending a week
                together, enjoying the beaches, sunsets, and time with the Lord.
              </p>
              <p>
                You will spend 7 days, 6 nights on the beautiful “Garden Isle”,
                Kauai, Hawaii, with no children, no work, no to-do’s, and no
                distractions. Be refreshed by the Word of God, uplifted by
                inspirational messages & times of worship, and encouraged by
                fellowship with other believers.
              </p>
              <p>
                Join us on the Love Song Couples Getaway, {tripData.dates} at
                the exquisite 5-Star {tripData.venue}, and create memories that
                will last a lifetime!
              </p>
            </div>
          ) : trip === "kauai2021" ? (
            <div>
              <p>
                Picture this, you blissfully awaken to the soft rays of the sun
                warming your face… …step out of your oversized guest room onto
                your lanai to delight in the tropical surroundings… …walk along
                the sandy beach hand-in-hand with your spouse… …take a stroll
                over to the elegant Grand ballroom to sing praises to the Lord
                during morning worship led by Steven Curtis Chapman, followed by
                a teaching from Gary Thomas, author of Sacred Marriage… …then
                it’s off to the pool to take a dip in the refreshing aqua blue
                water… …and that’s just the beginning! The Love Song Couples
                Getaway will allow you and your spouse to escape from the
                stresses of day-to-day life by spending a week together,
                enjoying the beaches, sunsets, and time with the Lord.
              </p>
              <p>
                You will spend 7 days, 6 nights on the beautiful “Garden Isle”,
                Kauai, Hawaii, with no children, no work, no to-do’s, and no
                distractions. Be refreshed by the Word of God, uplifted by
                inspirational messages & times of worship, and encouraged by
                fellowship with other believers.
              </p>
              <p>
                Join us on the Love Song Couples Getaway, {tripData.dates} at
                the exquisite 5-Star {tripData.venue}, and create memories that
                will last a lifetime!
              </p>
            </div>
          ) : trip === "maui2021" ? (
            <div>
              <p>
                Picture this, you blissfully awaken to the soft rays of the sun
                warming your face… …step out of your oversized guest room onto
                your lanai to delight in the tropical surroundings… …walk along
                the sandy beach hand-in-hand with your spouse… …take a stroll
                over to the elegant Fairmont Kea Lani ballroom to sing praises to the Lord
                during morning worship led by Steven Curtis Chapman, followed by
                a teaching from Gary Thomas, author of Sacred Marriage… …then
                it’s off to the pool to take a dip in the refreshing aqua blue
                water… …and that’s just the beginning! The Love Song Couples
                Getaway will allow you and your spouse to escape from the
                stresses of day-to-day life by spending a week together,
                enjoying the beaches, sunsets, and time with the Lord.
              </p>
              <p>
                You will spend 7 days, 6 nights on the beautiful island of Maui,
                Hawaii, with no children, no work, no to-do’s, and no
                distractions. Be refreshed by the Word of God, uplifted by
                inspirational messages & times of worship, and encouraged by
                fellowship with other believers.
              </p>
              <p>
                Join us on the Love Song Couples Getaway, {tripData.dates} at
                the exquisite 5-Star {tripData.venue}, and create memories that
                will last a lifetime!
              </p>
            </div>
          ) : (
            ""
          )}
          <ul>
            <li>Tropical Destination</li>
            <li>5-Star Oceanfront Resort</li>
            {!tripData.disableMonthlyPaymentOption && (
              <li>Affordable Monthly Payment Plans</li>
            )}
            <li>Acoustic Performances</li>
            <li>Marriage Focused</li>
            <li>Phenomenal Teachings</li>
            <li>Christian Fellowship</li>
            <li>Morning Worship</li>
            <li>Memorable Experiences</li>
          </ul>
          {!tripData.soldOut && !tripData.disableMonthlyPaymentOption && (
            <h3>Starting at ${lowestPrice} pp/mo</h3>
          )}
          {!tripData.soldOut && !tripData.disableMonthlyPaymentOption && (
            <Link className="btn btn-rounded" to={`/${trip}/prices/`}>
              Book Now!
            </Link>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/book-callout.js